import { render, staticRenderFns } from "./TheLinkText.vue?vue&type=template&id=27eb9c84"
import script from "./TheLinkText.vue?vue&type=script&lang=ts"
export * from "./TheLinkText.vue?vue&type=script&lang=ts"
import style0 from "./TheLinkText.vue?vue&type=style&index=0&id=27eb9c84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports